var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import StyleBase from "../../common/styleBase";
var ComponentStyles = /** @class */ (function (_super) {
    __extends(ComponentStyles, _super);
    function ComponentStyles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.componentStylesBase = {
            logo: {
                margin: "0 14px 0 0",
                width: "36px",
            },
            container: {
                alignItems: "center",
                backgroundColor: "#202020",
                borderBottom: "1px solid #353535",
                boxSizing: "border-box",
                display: "flex",
                height: "4.5rem",
                fontSize: "1.35rem",
                fontWeight: 700,
                color: "#f4f6f2",
                letterSpacing: "0",
                minHeight: "4.5rem",
                width: "100%",
            },
            menuContainer: {
                width: "3rem",
            },
            menu: {
                root: {
                    backgroundColor: "transparent",
                    color: "white",
                },
                rootFocused: {
                    backgroundColor: "transparent",
                    color: "white",
                },
                icon: {
                    fontSize: "1.4rem",
                },
            },
            logoContainer: {
                display: "flex",
                alignContent: "center",
                alignItems: "center",
                padding: "0 clamp(1.25rem, 3vw, 3.5rem)",
                width: "100%",
            },
        };
        _this.componentStylesSmallDevice = __assign(__assign({}, _this.componentStylesBase), { container: __assign(__assign({}, _this.componentStylesBase.container), { justifyContent: "flex-end", textAlign: "right" }), menuContainer: {
                marginLeft: "1rem",
            }, textContainer: {
                flexGrow: 2,
                textAlign: "center",
            }, logoContainer: {
                padding: "0 1rem 0 0",
            } });
        return _this;
    }
    return ComponentStyles;
}(StyleBase));
export default ComponentStyles;
